import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { formatMoney } from "../../../../helpers/formatter";
import React, { useState } from "react";
import {
  ProviderAccount,
  ProvidersResponse,
} from "../../../../custom-hooks/useFetchOutwardTransferProviders";
import {
  ChannelType,
  useFetchProviderBalanceEnquiry,
} from "../../../../custom-hooks/useFetchProviderBalanceEnquiry";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import Loader from "../../../../NewComponents/Loader/Loader.component";

interface IBankDetailsProps {
  transferProviders: ProvidersResponse;
}

const AccountRow = ({
  providerName,
  account,
}: {
  providerName: string;
  account: ProviderAccount;
}) => {
  const [isRevealed, setIsRevealed] = useState(false);

  const { data, isFetching } = useFetchProviderBalanceEnquiry({
    bankCode: account.bankCode,
    accountNumber: account.accountNumber,
    channelCode: ChannelType.WEB,
    isReveal: isRevealed,
  });

  const handleToggle = () => setIsRevealed((prev) => !prev);

  return (
    <tr>
      <td>{providerName}</td>
      <td>{account.bankName || "N/A"}</td>
      <td>{account.accountNumber}</td>
      <td>{account.accountName}</td>
      <td
        className={`${account.isSetProviderAccount ? "green-100 text-success" : "red-100 text-danger"}`}
      >
        {account.isSetProviderAccount ? "Active" : "Inactive"}
      </td>
      <td className="flex items-center gap-2">
        ₦
        {isRevealed ? (
          isFetching ? (
            <Loader />
          ) : data?.availableBalance ? (
            formatMoney(data.availableBalance)
          ) : (
            "0.00"
          )
        ) : (
          "************"
        )}
        <span style={{ cursor: "pointer", marginLeft: "8px" }}>
          {isRevealed ? (
            <EyeInvisibleOutlined onClick={handleToggle} />
          ) : (
            <EyeOutlined onClick={handleToggle} />
          )}
        </span>
      </td>
    </tr>
  );
};

const BankDetails = ({ transferProviders }: IBankDetailsProps) => {
  return (
    <div className="w-full mt-40">
      <MDBTable
        responsive
        minimal="true"
        striped
        bordered
        hover
        id="table-to-xls"
      >
        <MDBTableHead>
          <tr>
            <th>Provider</th>
            <th>Bank Name</th>
            <th>Account Number</th>
            <th>Account Name</th>
            <th>Status</th>
            <th>Account Balance</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {transferProviders?.data?.providers
            ?.filter((provider) => provider.accounts?.length > 0)
            .map((provider) =>
              provider.accounts.map((account) => (
                <AccountRow
                  key={`${provider.id}-${account.id}`}
                  providerName={provider.name}
                  account={account}
                />
              )),
            )}
        </MDBTableBody>
      </MDBTable>
    </div>
  );
};

export default BankDetails;
